import axios from 'axios';

// Serialize params so arrays become repeated keys: key=val1&key=val2
// (Django's request.GET.getlist expects this format, not key[]=val1&key[]=val2)
export const serializeParams = params => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => searchParams.append(key, String(v)));
    } else if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
};

const withAuth = fn => args => {
  const headers = {};

  const accessToken = localStorage.getItem('access-token');
  if (accessToken) {
    headers['Authorization'] = `Token ${accessToken}`;
  }
  return fn({ ...args, headers });
};

const _request = ({ method, url, data, params, headers, responseType }) => {
  const contentType =
    data instanceof FormData ? 'multipart/form-data' : 'application/json';

  return axios({
    headers: {
      ...headers,
      'Content-Type': contentType,
    },
    method,
    url,
    data,
    params,
    paramsSerializer: serializeParams,
    responseType,
  }).then(response => response.data);
};

export const request = withAuth(_request);

export const setErrorResponseHandler = handler => {
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      return handler(error);
    },
  );
};



// WEBPACK FOOTER //
// ./src/utils/rest-service.js